/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {
    DISPLAY_MESSAGE,
    REMOVE_MESSAGE
} from 'state/actions/message_status';
import { CLEAR_ALL_STATES } from 'state/actions/auth_status';
// utils
import { generateId } from 'utils/generators';
// import { log } from 'utils/logger';



/* ========== ~~~~~~~~~~ MESSAGE STATUS : REDUCER ~~~~~~~~~~ ========== */

const defaultState = {
    toasters: {
        top: [],
        bottom: []
    },
    notifications: {
        top: [],
        bottom: []
    }
};


// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components
const messageStatus = (state = defaultState, action) => {
    switch (action.type) {
        case DISPLAY_MESSAGE:
            const message = { ...action.message, id: generateId() };
            let position = action.message.align.includes('top') ? 'top' : 'bottom';
            return {
                ...state,
                [`${action.message.type}s`]: {
                    ...state[`${action.message.type}s`],
                    [position]: state[`${action.message.type}s`][position].concat(message)
                }
            };
        case REMOVE_MESSAGE:
        position = action.alignment.includes('top') ? 'top' : 'bottom';
        return {
            ...state,
            [`${action.messageType}s`]: {
                ...state[`${action.messageType}s`],
                [position]: state[`${action.messageType}s`][position].filter(message => message.id !== action.id)
            }
        };
        case CLEAR_ALL_STATES:
            return defaultState;
        default:
            return state;
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default messageStatus;